import _ from 'lodash';

const MODAL_MAX_WIDTH = 768;
const MODAL_VERTICAL_MARGINS_IN_CALL = 165;
const MODAL_VERTICAL_MARGINS_IDLE = 80;

export default angular
  .module('doxy.realtime.components.teleconsent.action.tc-modal-adaptive', [])
  .directive(
    'tcModalAdaptive',
    function ($timeout, VideoProviderFactory, Browser) {
      //tc-modal-adaptive
      return {
        restrict: 'A',
        link: function (scope, elem) {
          const me = scope.$parent.me;
          const innerMediator = scope.$parent.innerMediator;

          let unsubscribeResizer = angular.noop;

          const element = elem;

          const checkMediaClass = (width) => {
            if (width < MODAL_MAX_WIDTH) {
              element.addClass('mod-mobile');
            } else {
              element.removeClass('mod-mobile');
            }
          };
          const resize = _.debounce(() => {
            const modal = document.getElementById('tc-modal-wrapper');
            const elementSize = {
              height: modal?.clientHeight,
              width: element[0].clientWidth,
              isMobile: Browser.isMobileScreen(),
            };
            checkMediaClass(elementSize.width);
            innerMediator.emit('resize', elementSize);
          }, 1000);

          if (me.type === 'p') {
            $timeout(() => resize());
            unsubscribeResizer = window.addEventListener('resize', resize);
          }

          if (me.type === 'r') {
            // Ensure innerMediator is available before setting up event listeners
            if (innerMediator && typeof innerMediator.on === 'function') {
              innerMediator.on('resize:get', (elementSize) => {
                checkMediaClass(elementSize.width);
                const width =
                  elementSize.width > MODAL_MAX_WIDTH
                    ? MODAL_MAX_WIDTH
                    : elementSize.width;
                element[0].setAttribute(
                  'style',
                  `display: block; width: ${width}px !important;`
                );

                const modal = document.getElementById('tc-modal-wrapper');
                const verticalMargins = VideoProviderFactory.activeProvider
                  .isInCall
                  ? MODAL_VERTICAL_MARGINS_IN_CALL
                  : MODAL_VERTICAL_MARGINS_IDLE;
                const padding = elementSize.isMobile ? 40 : 0;

                if (
                  elementSize.height <
                  document.documentElement.clientHeight - verticalMargins
                ) {
                  modal.setAttribute(
                    'style',
                    `${modal.getAttribute('style')}; height: ${
                      elementSize.height - padding
                    }px !important`
                  );
                } else {
                  modal.setAttribute(
                    'style',
                    `${modal.getAttribute('style')}; height: auto !important`
                  );
                }
              });
            } else {
              console.warn('TcModalAdaptive: innerMediator not available or missing on method');
            }
          }
          scope.$on('$destroy', unsubscribeResizer);
        },
      };
    }
  ).name;
